import { gql } from '@apollo/client';

export default gql`
  query getVoucherDetails($voucherAlias: String!, $voucherType: String) {
    findVoucherByReferenceAndMarket(reference: $voucherAlias, voucherType: $voucherType) {
      createdFor
      businessAccount
      reference
      alias
      type
      value
      valueType
      isActive
      balance
      currency
      status
      customerEmail
      firstName
      lastName
      salesPeriodStart
      salesPeriodEnd
      travelPeriodStart
      travelPeriodEnd
      travelDays
      createdBy
      createdAt
      updatedBy
      updatedAt
      activatedAt
      inactivatedAt
      payments {
        amount
        currency
        status
        bookingReference
      }
      description
      language
      associatedPNR
      replacedByVoucher
      associatedVoucher
      travelPeriodExceptions {
        startDate
        endDate
      }
      salesChannelRestrictions {
        includedSalesChannels {
          salesChannelCode
        }
      }
      countryRestrictions
      productRestrictions {
        productCode
      }
      settings {
        usageType
        usageLimit
        spendingRestrictionType
        minRequiredGroupSize
        maxRequiredGroupSize
        usageRestrictionType
        tripRestrictionType
      }
      stationRestrictions {
        stationUicCode
        role
      }
      maxTotalDiscountAmount
      minBookingValue
      maxBookingValue
    }
  }
`;
